import { Injectable } from '@angular/core';
import { ProcedureEnum } from '@core/procedure-helpers/models/procedure.enum';
import { ApiService, IApiCall } from '@core/services/api.service';
import { OrderQuery } from '@modules/order/state/order-query';
import { ResendScanResponse } from '@modules/rx-for-doctor/models/resend-scan-response';
import { ShellQuery } from '@shared/store/shell/shell-query';
import { RxModel } from '@shared/models/rx-models/interfaces/rx-model';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ResendScanService {
	private static readonly subTypesDisabledForProceduresForResendFlow: ProcedureEnum[] = [ProcedureEnum.Denture_Removable];

	readonly isResendScanSubTypeLocked$: Observable<boolean> = combineLatest([
		this.shellQuery.isResendScan$,
		this.orderQuery.procedureMap$
	]).pipe(
		map(
			([isResendScan, procedureMap]) =>
				isResendScan && ResendScanService.subTypesDisabledForProceduresForResendFlow.includes(procedureMap?.ProcedureId as ProcedureEnum)
		)
	);

	constructor(
		private readonly apiService: ApiService,
		private readonly shellQuery: ShellQuery,
		private readonly orderQuery: OrderQuery
	) {}

	resendScan(orderId: number, rxForm: RxModel): Observable<ResendScanResponse | null | undefined> {
		const payload = {
			OrderId: orderId,
			RxForm: rxForm
		};

		const config: IApiCall = {
			selector: 'resendScan',
			options: { observe: 'response', body: payload }
		};

		return this.apiService.request(config).pipe(map(response => response?.body));
	}
}
